module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-sheet', {
    staticClass: "pa-4",
    class: _vm.showDetails ? 'secondary' : 'primary'
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.isMovil || !_vm.isMovil && _vm.showDetails) ? _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "fab": "fab",
      "icon": "icon",
      "small": "small"
    },
    on: {
      "click": function($event) {
        _vm.showDetails ? _vm.closeOpciones() : _vm.close()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.showDetails ? 'primary' : 'white',
      "size": "25"
    }
  }, [_vm._v("arrow_back")])], 1) : _vm._e(), (!_vm.showDetails) ? _c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Buscar en configuraciones",
      "dark": "",
      "flat": "",
      "solo-inverted": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    on: {
      "input": _vm.buscarValor
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _c('div', {
    staticClass: "d-flex flex-1 ai-center"
  }, [_c('span', {
    staticClass: "primary--text font-weight-700 font-size-20"
  }, [_vm._v(_vm._s(_vm.showOptions.titulo))]), _c('v-spacer')], 1)], 1)]), (_vm.showAlertReload) ? _c('v-alert', {
    attrs: {
      "prominent": "",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('small', [_vm._v("Al realizar cualquier cambio en las configuraciones de la aplicacion es recomendable presionar F5 o darle click en el siguiente boton")]), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "white warning--text",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.reloadPage()
      }
    }
  }, [_vm._v("Actualizar pagina")])], 1), _c('v-btn', {
    attrs: {
      "small": "small",
      "icon": "icon"
    },
    on: {
      "click": function($event) {
        return _vm.closeAlertReload()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1)]) : _vm._e(), _c('div', {
    staticClass: "box-settings",
    class: _vm.showAlertReload ? 'reload' : ''
  }, [(_vm.configuraciones.length && !_vm.showDetails) ? _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense",
      "flat": "flat",
      "two-line": ""
    }
  }, [_vm._l((_vm.configuraciones), function(c, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.openOpciones(c)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', {
      staticClass: "background"
    }, [_vm._v(_vm._s(c.icon))])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(c.titulo))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(c.subtitulo))])], 1), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v(" chevron_right")])], 1)], 1)], 1)
  }), _c('v-list-item', [_c('v-list-item-content', [_c('theme-provider')], 1)], 1)], 2) : _vm._e(), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense",
      "flat": "",
      "two-line": ""
    }
  }, [(_vm.showDetails && _vm.showOptions.key === 'general') ? _c('v-list-item', [_c('v-list-item-content', {
    staticClass: "py-6"
  }, [_c('v-list-item-title', [_vm._v("Habilitar Modo Oscuro")]), _c('v-list-item-subtitle', {
    staticClass: "font-size-12"
  }, [_vm._v("Alarga la duración de la batería, Reduce la fatiga visual, Ayuda a la lectura etc.")])], 1), _c('v-list-item-action', [_c('v-switch', {
    attrs: {
      "dense": "dense"
    },
    model: {
      value: (_vm.isDark),
      callback: function($$v) {
        _vm.isDark = $$v
      },
      expression: "isDark"
    }
  })], 1)], 1) : _vm._e()], 1), (_vm.search && !_vm.configuraciones.length) ? _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-alert', {
    attrs: {
      "text": "",
      "dense": "dense",
      "type": "error",
      "icon": "settings"
    }
  }, [_c('small', [_vm._v("Ninguna coincidencia para esta busqueda")])])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex mx-4 my-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "success",
      "dark": "dark",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": _vm.fetchGuardarConfiguraciones
    }
  }, [_vm._v("Guardar configuraciones")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bc3e4aa","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_configuraciones_app.vue
// module id = 515
// module chunks = 1